import React from "react";
import { Scissors } from "lucide-react";
import { hasTulFonItems } from "../utils/tulFonSheetModel";
import "./tailorResponsive.css";

export const TailorSheetButton = ({ record, onClick, testId }) => {
  if (!hasTulFonItems(record)) return null;
  return <button type="button" data-testid={testId} title="Tül / Fon Terzi Föyü" onClick={event => { event.stopPropagation(); onClick(); }}
    className="inline-flex max-w-full items-center justify-center gap-1.5 px-2.5 py-1.5 rounded-md border border-sky-600/40 bg-sky-50 text-sky-800 dark:bg-sky-950 dark:text-sky-200 text-xs font-bold hover:bg-sky-100 dark:hover:bg-sky-900 active:scale-[0.98] transition-[background-color,transform]">
    <Scissors className="w-3.5 h-3.5 shrink-0" /> Terzi Föyü
  </button>;
};